import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { maybePluralize, maybePluralizeWithNum } from '@chegg-wt/core/utils/language'
import { DELETE_MODAL } from '@chegg-wt/core/state/modals/constants'

import { AppState } from '@chegg-wt/core/state'
import {
  CITATION_LIST_NAME_LOWER_SINGLE,
  CITATION_LIST_NAME_SINGLE,
  CITATION_LIST_NAME_PLURAL,
} from '@chegg-wt/core/constants/citations'
import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import { deleteCitations } from '@chegg-wt/core/state/bibliography/actions'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { Modal } from '..'
import { DeleteModalBase } from './DeleteModalBase'

export const deleteCitationsTitle = (totalCitations: number) =>
  `Delete ${maybePluralizeWithNum(totalCitations, 'citation', 'citations')}`

export const deleteCitationsDescription = (totalCitations: number) => `${maybePluralize(
  totalCitations,
  CITATION_LIST_NAME_SINGLE,
  CITATION_LIST_NAME_PLURAL
)} \
will be permanently deleted from this ${CITATION_LIST_NAME_LOWER_SINGLE}.`

interface OwnProps {
  modalData: {
    citations: Citation[]
  }
}

interface StateProps {
  title: string
  description: string
}

interface DispatchProps {
  handleConfirm: () => void
  handleClose: () => void
}

type Props = StateProps & DispatchProps

export const DeleteCitationsModal: React.FC<Props> = ({ handleClose, ...props }) => (
  <Modal showModal closeButton outsideClick onClose={handleClose}>
    <DeleteModalBase {...props} handleClose={handleClose} />
  </Modal>
)

const mapStateToProps = (state: AppState, ownProps: OwnProps) => ({
  title: deleteCitationsTitle(ownProps.modalData.citations.length),
  description: deleteCitationsDescription(ownProps.modalData.citations.length),
})

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps) => ({
  handleConfirm() {
    dispatch(deleteCitations(ownProps.modalData.citations))
  },
  handleClose() {
    dispatch(closeModal(DELETE_MODAL))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModalBase)
